import { FEATURES } from '@/src/constants/Text'

export const LABEL_PROFISSIONAIS = 'Profissionais'
export const LABEL_AREA = 'Área de Produto'

export const COMMISSION_TYPE = 'Comissão'

// Chave de localStorage dos filtros da Visão Geral (persistência com reset mensal — CU-86aajcqwx)
export const STORAGE_KEY_VISAO_GERAL_FILTROS = 'comissoes-visao-geral-filtros'

const isManager = (user, show) => {
  return user.IS_GESTOR && show[FEATURES.COMISSOES_MANAGER]
}
// Subtítulos das abas de topo — exibidos no route-header da NavBarNavigation
// (novo design). Casados por `name` da rota. Fonte única do texto.
export const COMISSOES_ROUTE_SUBTITLE = {
  'comissoes.visao-geral': 'Resumo operacional das comissões',
  'comissoes.fechamentos': 'Apure e feche as comissões do mês',
  'comissoes.pagamentos': 'Folha de pagamento das comissões',
  'comissoes.roa': 'Custódia, receita e ROA por profissional',
  'comissoes.ia': 'Pergunte sobre o fechamento ao agente de comissionamento',
}

// Copy da aba de IA (Especialista em Comissionamento). Rótulo, headline e
// placeholder NÃO moram aqui: vêm do registro da persona
// (`@modules/aawz-intelligence-v2/constants/Personas`), que é a fonte única
// compartilhada com a bolha da mensagem — duplicar faria as duas divergirem.

// Perguntas de partida do estado vazio. São as que o gestor faz ao abrir o
// fechamento; todas respondidas por tool, nunca por texto gerado.
export const COMISSOES_IA_SUGESTOES = [
  'Como ficou o comissionamento deste mês por profissional?',
  'Quais regras se aplicam a uma linha de receita?',
  'Quais ajustes manuais entraram neste fechamento?',
]

// Erro de quando a conversa nem chega a abrir (rede, 403 da funcionalidade). Traz
// a próxima ação: mensagem que só descreve o problema deixa o gestor travado.
export const COMISSOES_IA_ERRO_ENVIO =
  'Não foi possível falar com o agente agora. Tente novamente em instantes.'

// Cor do badge de status da competência na aba ROA, por token do design system
// (o BaseStatus resolve `warning-new` como `var(--warning-new)`): âmbar enquanto
// o mês está em apuração, verde depois de disponibilizado aos assessores. Status
// fora do mapa cai no `defaultColor` do BaseStatus.
export const ROA_STATUS_COLORS = {
  'Em aberto': 'warning-new',
  Disponibilizado: 'success',
}

export const comissoesOptionsRoutes = (user, show) => {
  let router = []
  if (
    (user.IS_INTERNAL && show[FEATURES.COMISSOES_INTERNAL]) ||
    (!user.IS_INTERNAL && show[FEATURES.COMISSOES])
  ) {
    router = [
      show[FEATURES.COMISSOES_OVERVIEW] && {
        name: 'comissoes.visao-geral',
        title: 'Visão Geral',
      },

      { name: 'comissoes.fechamentos', title: 'Fechamentos' },

      isManager(user, show) && {
        name: 'comissoes.pagamentos',
        title: 'Pagamentos',
      },

      isManager(user, show) &&
        show[FEATURES.COMISSOES_ROA] && {
          name: 'comissoes.roa',
          title: 'ROA',
        },

      // Aba do Especialista em Comissionamento, na mesma ordem da nav-bar.
      // Gate SÓ pela flag, sem `isManager`: o backend gateia `/comissoes/chat`
      // pela funcionalidade do escritório, não pelo papel — o assessor abre o
      // chat e só toma 403 nas dez tools de configuração, que são gestor-only.
      // Exigir gestor aqui esconderia a feature de quem tem direito a ela.
      show[FEATURES.IA_COMISSOES] && {
        name: 'comissoes.ia',
        title: 'IA',
      },
    ]
  }

  return router.filter((item) => item)
}

export const MAP_KEY_REPORT = {
  comissoes: 'Todas as Comissões',
  pagamentos: 'Todos os Pagamentos',
  categoria: 'Detalhamento de Receita por Data, Profissional e Categoria',
  cliente: 'Detalhamento de Receita por Data, Profissional e Cliente',
  categoria_produto_cliente_profissional:
    'Detalhamento de Receita por Origem, Categoria, Produto, Cliente e Profissional',
}

export const IDS_CALCULO_PERFORMANCE = [30]

// Filtros da Visão Geral: chaves de data que não devem ser ordenadas
// alfabeticamente e nomes de opção "default" que ficam sempre no topo.
export const SORT_FILTER_IGNORE_KEYS = ['data_inicio', 'data_final']
export const DEFAULT_OPTIONS = ['todos', 'todas']
